export const country = window.ocm?.config?.country || "de";
export const language = window.ocm?.config?.language || "de";
export const contextPath = window.ocm?.config?.encodedContextPath ?? `/${country}-de/shop`;
export const isClassicSite = window.ocm?.isClassicSite ?? false;
export const shopContextPath = isClassicSite ? `/${country}-de/shop` : contextPath;

// Epoq
export const isEpoqRecosCartEnabled = window.ocm?.config?.isEpoqRecosCartEnabled;
export const epoqRecosPlpChunkSize = window.ocm?.config?.epoqRecosPlpChunkSize;
export const isEpoqRecosPdpEnabled = window.ocm?.config?.isEpoqRecosPdpEnabled;

// Contact Center
export const captchaPublickey = window.ocm?.captchaOptions?.publickeyContactcenter || "";
export const captchaActive = window.ocm?.captchaOptions?.displayContactcenter;

export const department = window.ocm?.config?.department;

// My Account
export const memberGetsMemberClassicEnabled = window.ocm?.config?.memberGetsMemberClassicEnabled ?? false;
export const memberGetsMemberShopEnabled = window.ocm?.config?.memberGetsMemberShopEnabled ?? false;

// TUB-22966 Gutschein-Code-Position A/B-Test
export const isVoucherCodeBelowReco = window.ocm?.config?.isVoucherCodeBelowReco ?? true;
export const isVoucherCodeAboveReco = window.ocm?.config?.isVoucherCodeAboveReco ?? false;
export const isVoucherCodeOnTop = window.ocm?.config?.isVoucherCodeOnTop ?? false;

// TUB-21842 Category and Filter Chips A/B-Test
export const isCategoryAndFilterChipsEnabled = window.ocm?.config?.isCategoryAndFilterChipsEnabled ?? false;

// TUB-21783 Recommendation below PLP A/B-Test
export const isRecommendationBelowPlpEnabled = window.ocm?.config?.isRecoBelowPLPEnabled ?? false;

export const isMinifiedHeaderCartEnabled = window.ocm?.config?.isMinifiedHeaderCartEnabled ?? false;
